<template>
  <div class="status-card">
    <a-card class="block-container" bordered>
      <div class="status-header">
        <div>
          {{ labels[type].header }}
        </div>
        <RightOutlined class="right-arrow-icon" @click="router.push(type === 'test' ? '/rating' : '/courses')"/>
      </div>

      <div class="filters">
        <a-select
            v-model:value="selectedEvaluation"
            :placeholder="labels[type].placeholderSelect"
            style="width: 100%;"
            @change="fetchStatusData"
            :not-found-content="'Нет данных'"
        >
          <a-select-option v-for="e in evaluations" :key="e.id" :value="e.id">
            {{ e.name }}
          </a-select-option>
        </a-select>

        <a-select
            v-model:value="selectedTags"
            mode="multiple"
            :placeholder="labels[type].placeholderMultiselect"
            style="width: 100%;"
            @change="fetchStatusData"
            @select="handleTagsSelect"
            :not-found-content="'Нет данных'"
        >
          <a-select-option v-for="item in availableTags" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <div v-if="statusData" class="progress-container">
        <div class="progress-bar">
          <div v-if="percent.done" class="segment done" :style="{ width: percent.done + '%' }"></div>
          <div v-if="percent.inProgress" class="segment in-progress" :style="{ width: percent.inProgress + '%' }"></div>
          <div v-if="percent.notStarted" class="segment not-started" :style="{ width: percent.notStarted + '%' }"></div>
        </div>
      </div>

      <div v-if="statusData" class="status-list">
        <div class="status-row">
          <div class="status-left">
            <span class="dot done"></span>
            <span class="label">Прошли</span>
          </div>
          <div class="status-right">
            <span class="count">{{ counts.done }}</span>
            <span class="percent">{{ percent.done }}%</span>
          </div>
        </div>

        <div class="status-row">
          <div class="status-left">
            <span class="dot in-progress"></span>
            <span class="label">В процессе</span>
          </div>
          <div class="status-right">
            <span class="count">{{ counts.inProgress }}</span>
            <span class="percent">{{ percent.inProgress }}%</span>
          </div>
        </div>

        <div class="status-row">
          <div class="status-left">
            <span class="dot not-started"></span>
            <span class="label">Не начали</span>
          </div>
          <div class="status-right">
            <span class="count">{{ counts.notStarted }}</span>
            <span class="percent">{{ percent.notStarted }}%</span>
          </div>
        </div>
      </div>

      <div class="button-container">
        <a-button
            type="default"
            class="secondary-button"
            :disabled="!statusData"
            @click="showNotificationWindow = true"
        >
          Направить напоминание
        </a-button>
      </div>

      <a-spin v-if="loading" class="loading-overlay" />
    </a-card>

    <NotifyAboutPassingsForm
      :formOpen="showNotificationWindow"
      :type="type"
      :availableTags="availableTags"
      :passingProduct="selectedEvaluation"
      :labels="labels"
      @closeForm="showNotificationWindow = false"
    />
  </div>

</template>

<script>
import { ref, computed } from 'vue';
import getReportName from "@/mixins/getReportName";
import {useStore} from "vuex";
import {onBeforeMount, watch} from "@vue/runtime-core";
import {PlusOutlined, RightOutlined} from "@ant-design/icons-vue";
import NotifyAboutPassingsForm from "@/components/Forms/User/NotifyAboutPassingsForm.vue";
import {useRouter} from "vue-router";
export default {
  props: {
    type: String,
  },
  components: {NotifyAboutPassingsForm, RightOutlined, PlusOutlined},
  setup(props) {
    const store = useStore();

    const companyActivityData = computed(() => store.state.companyActivity);

    const selectedEvaluation = ref(null);
    const selectedTags = ref([]);

    const evaluations = ref([]);
    const availableTags = ref([]);

    const statusData = ref(null);
    const loading = ref(false);

    const showNotificationWindow = ref(false);
    const router = useRouter();

    const labels = {
      test: {
        header: 'Статус по оценке',
        placeholderSelect: 'Все оценки',
        placeholderMultiselect: 'Фильтр по группам',
        notificationFormHeader: 'Оценка',
      },
      course: {
        header: 'Статус по развитию',
        placeholderSelect: 'Все продукты',
        placeholderMultiselect: 'Фильтр по группам',
        notificationFormHeader: 'Развитие',
      },
    }

    const counts = ref({
      done: 0,
      inProgress: 0,
      notStarted: 0,
    });

    const percent = computed(() => {
      const total = counts.value.done + counts.value.inProgress + counts.value.notStarted;
      if (!total) return {done: 0, inProgress: 0, notStarted: 0};
      return {
        done: Math.round((counts.value.done / total) * 100),
        inProgress: Math.round((counts.value.inProgress / total) * 100),
        notStarted: Math.round((counts.value.notStarted / total) * 100),
      };
    });

    const fetchEvaluations = () => {
      let tempArray = [{
        id: 'all',
        name: 'Все ' + (props.type === 'test' ? 'оценки' : 'продукты'),
      }];

      let tempData;

      if (props.type === 'test') {
        tempData = Object.entries(companyActivityData.value?.tests?.by_group).filter(([key]) => key !== 'all').map(([key], el) => {
          return {
            id: key,
            name: getReportName(key)
          }
        });
      } else {
        tempData = companyActivityData.value?.courses?.by_group?.map((el) => {
          return {
            id: el.external_id,
            name: el.course_name,
          }
        });
      }

      evaluations.value = tempArray.concat(tempData);
      selectedEvaluation.value = 'all';
    };

    const fetchAvailableTags = () => {
      let allTags = [
        {
          id: 'all',
          name: 'Все группы'
        }
      ];

      let tags = companyActivityData.value?.groups?.map((el) => {
        return {
          id: el.id,
          name: el.name,
        }
      });

      availableTags.value = allTags.concat(tags);
      selectedTags.value = ['all'];
    }

    const handleTagsSelect = (val, option) => {
      if (val === 'all') {
        selectedTags.value = ['all'];
      } else {
        selectedTags.value = selectedTags.value.filter((el) => el !== 'all');
      }
    }

    const fetchStatusData = () => {
      loading.value = true;

      try {
        let data = props.type === 'test' ? handleTestFiltration() : handleCourseFiltration();
        counts.value = data;
        statusData.value = data;
      } finally {
        loading.value = false;
      }
    };


    const handleTestFiltration = () => {
      let data = {
        done: 0,
        inProgress: 0,
        notStarted: 0,
      };

      if (selectedEvaluation.value && selectedEvaluation.value !== 'all') {
        let testData = Object.entries(companyActivityData.value?.tests?.by_group)
            .find(([key]) => key === selectedEvaluation.value)[1] ?? [];

        Object.values(testData).forEach((item) => {
          if ((selectedTags.value.length && selectedTags.value.includes(item.group_id)) ||
              ((!selectedTags.value.length || selectedTags.value.includes('all')) && item.group_id === 'all')) {
            data.done += item.finished ?? 0;
            data.inProgress += item.in_progress ?? 0;
            data.notStarted += item.new ?? 0;
          }
        });
      } else {
        for (const items of Object.values(companyActivityData.value?.tests?.by_group)) {
          if (selectedTags.value.length && !selectedTags.value.includes('all')) {
            items.forEach((subItem) => {
              if (selectedTags.value.includes(subItem.group_id)) {
                data.done += subItem.finished ?? 0;
                data.inProgress += subItem.in_progress ?? 0;
                data.notStarted += subItem.new ?? 0;
              }
            });
          } else {
            let testData = items.find((el) => el.group_id === 'all');
            data.done += testData.finished ?? 0;
            data.inProgress += testData.in_progress ?? 0;
            data.notStarted += testData.new ?? 0;
          }
        }
      }

      return data;
    }

    const handleCourseFiltration = () => {
      let data = {
        done: 0,
        inProgress: 0,
        notStarted: 0,
      };

      if (!selectedEvaluation.value || selectedEvaluation.value === 'all') {
        companyActivityData.value?.courses?.by_group.map((el) => {
          if (!selectedTags.value.length || selectedTags.value.includes('all')) {
              let allInsideCourse = el.groups.find((subEl) => subEl.group_id === 'all');
              data.done += allInsideCourse.finished ?? 0;
              data.inProgress += allInsideCourse.in_progress ?? 0;
              data.notStarted += allInsideCourse.new ?? 0;
          } else {
            el.groups.map((smallGroup) => {
              if (selectedTags.value.includes(smallGroup.group_id)) {
                data.done += smallGroup.finished ?? 0;
                data.inProgress += smallGroup.in_progress ?? 0;
                data.notStarted += smallGroup.new ?? 0;
              }
            })
          }
        });
      } else {
        companyActivityData.value?.courses?.by_group.find((el) => el.external_id === selectedEvaluation.value).groups.map((subEl) => {
          if ((selectedTags.value.length && selectedTags.value.includes(subEl.group_id) && subEl.group_id !== 'all') ||
              ((!selectedTags.value.length || selectedTags.value.includes('all')) && subEl.group_id === 'all')) {
            data.done += subEl.finished ?? 0;
            data.inProgress += subEl.in_progress ?? 0;
            data.notStarted += subEl.new ?? 0;
          }
        });
      }

      return data;
    }

    watch(() => companyActivityData.value, () => {
      if (companyActivityData.value.tests) {
        fetchEvaluations();
        fetchStatusData();
        fetchAvailableTags();
      }
    });

    return {
      statusData,
      percent,
      selectedTags,
      selectedEvaluation,
      availableTags,
      fetchStatusData,
      fetchEvaluations,
      evaluations,
      loading,
      counts,
      showNotificationWindow,
      handleTagsSelect,
      labels,
      router
    }
  }
}
</script>

<style scoped>
.status-card {
  flex: 1;
  min-width: 320px;
  background: #fff;
  border-radius: 8px;
}

.status-header {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: var(--main-font);
}

.filters {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 15px;
}

.progress-container {
  margin-bottom: 12px;
}

.progress-bar {
  display: flex;
  height: 8px;
  border-radius: 10px;
  overflow: hidden;
  column-gap: 2px;
}

.segment {
  height: 100%;
  transition: width 0.8s ease;
}

.segment.done {
  background-color: #73D13D;
}

.segment.in-progress {
  background-color: #597EF7;
}

.segment.not-started {
  background-color: #FFC53D;
}

.status-list {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.status-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #3d3d3d;
}

.label {
  font-weight: 400;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.dot.done {
  background-color: #73D13D;
}

.dot.in-progress {
  background-color: #597EF7;
}


.dot.not-started {
  background-color: #FFC53D;
}

.count {
  font-weight: 700;
}

.percent {
  font-weight: 500;
  color: var(--grey-text);
}

.button-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 12px;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255,255,255,0.5);
}
</style>
